import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from '../components/icons';

export function TermsPage() {
  return (
    <div className="min-h-screen freud-bg py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-chocolate-600 hover:text-sage-600 mb-8 transition-colors font-medium"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <div className="freud-card-elevated p-8">
          <div className="flex items-center gap-3 mb-8">
            <div className="p-3 bg-sage-100 rounded-xl">
              <FileText className="w-6 h-6 text-sage-600" />
            </div>
            <h1 className="freud-heading-2xl text-chocolate-900">Terms of Service</h1>
          </div>

          <div className="prose prose-chocolate max-w-none">
            <p className="freud-text-base text-chocolate-500 mb-6">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              By accessing and using NLP OS, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">2. Description of Service</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              NLP OS provides psychological assessments and AI-powered analysis to help individuals understand their potential, characteristics, and areas for growth. Our services are intended for personal development purposes only.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">3. User Accounts</h2>
            <p className="freud-text-base text-chocolate-600 mb-4">
              When you create an account with us, you must:
            </p>
            <ul className="list-disc pl-6 freud-text-base text-chocolate-600 space-y-2 mb-6">
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Promptly update any changes to your information</li>
              <li>Accept responsibility for all activities under your account</li>
            </ul>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">4. Assessment Results</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              Assessment results and AI analyses are provided for informational and personal development purposes only. They should not be used as a substitute for professional psychological evaluation, medical advice, or clinical diagnosis.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">5. Intellectual Property</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              All content, features, and functionality of the Platform are owned by us and are protected by copyright, trademark, and other intellectual property laws. You may not copy, modify, distribute, or create derivative works without our express written consent.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">6. User Conduct</h2>
            <p className="freud-text-base text-chocolate-600 mb-4">
              You agree not to:
            </p>
            <ul className="list-disc pl-6 freud-text-base text-chocolate-600 space-y-2 mb-6">
              <li>Use the Platform for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt the Platform</li>
              <li>Share your account credentials with others</li>
              <li>Use the Platform to harm or exploit others</li>
            </ul>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">7. Limitation of Liability</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Platform.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">8. Modifications</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              We reserve the right to modify these Terms at any time. We will notify users of any material changes via email or through the Platform.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">9. Contact</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              If you have questions about these Terms, please contact us at support@notify.nlpos.app.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
